import React, { Component } from "reactn";
import { List as AppList, ListField, ListIcon } from "../../../components/List";
import Api from "../../../../core/api";
import {
    ShowErrorDialog,
    ShowDialog,
    ShowMessageDialog, ShowConfirmationDialog
} from "../../../components/Dialogs/BaseDialog";
import log from "../../../../core/logger";
import AddTeamSeatDialog from "../dialogs/AddTeamSeatDialog";
import { app } from "js/namespaces";
import { trackActivity } from "../../../../core/utilities/utilities";
import { getUsedSeatCount } from "../UserOptionsContainer";
import Icon from "js/react/components/Icon";
import { ScaryButton } from "../../../components/UiComponents";
import { TEAM_USER_ROLES, TEAM_USER_LICENSE_STATUS, AnalyticsRolesAndLicensesMap } from "common/constants";
import { ds } from "js/core/models/dataService";
import BackgroundClick from "js/react/components/BackgroundClick";
import { Profile } from "js/react/components/Avatar";
import { Select, MenuItem } from "@material-ui/core";
import styled from "styled-components";

function getRoleUpdateText(user, role) {
    let text = { title: "", message: "" };

    switch (role) {
        case (TEAM_USER_ROLES.MEMBER):
        case (TEAM_USER_ROLES.MEMBER_LICENSED):
            text.title = `Do you want to change ${user.displayName || user.email} to a member?`;
            text.message = "They will only have access to shared team content.";
            break;
        case (TEAM_USER_ROLES.LIBRARIAN):
            text.title = `Do you want to change ${user.displayName || user.email} to a librarian?`;
            text.message = "They will be able add and manage slide, presentations, themes, and assets for the team.";
            break;
        case (TEAM_USER_ROLES.OWNER):
            text.title = `Do you want to change ${user.displayName || user.email} to a owner?`;
            text.message = "They will be able to manage payment info, add/remove members, add/remove seats, and change team permissions on resources.";
            break;
    }
    return text;
}

class TeamMembersList extends Component {
    state = {
        menuAnchorEl: null,
        readyToDelete: {}
    };

    refreshApp = () => {
        setTimeout(() => {
            window.location.href = "/";
        }, 50);
    };

    handleRemoveInvite = async email => {
        const { team, getTeam } = this.props;
        try {
            await Api.teams.put({
                teamId: team.id,
                type: "remove_invites",
                emails: [email]
            });
            getTeam();
        } catch (err) {
            if (err) {
                log.error(err);
                ShowErrorDialog({
                    error: "Failed to remove invite",
                    message: "Something went wrong. Please try again and reach out to support@beautiful.ai if the issue persists."
                });
            }
        }
    };

    handleRoleUpdate = async (user, role) => {
        const { org, team, getTeam } = this.props;
        const { title, message } = getRoleUpdateText(user, role);
        ShowConfirmationDialog({
            title,
            message
        }).then(async accept => {
            if (!accept) {
                return;
            }
            try {
                await Api.teams.put({
                    teamId: team.id,
                    orgId: org.id,
                    type: "update_roles",
                    userIds: [user.id],
                    role
                });

                const props = {
                    workspace_id: org.id,
                    affected_user: user.id,
                    old_role: AnalyticsRolesAndLicensesMap[user.role],
                    new_role: AnalyticsRolesAndLicensesMap[role],
                    old_license: AnalyticsRolesAndLicensesMap[user.license],
                    new_license: AnalyticsRolesAndLicensesMap[user.license]
                };
                trackActivity("Organization", "UserStatusChanged", null, null, props, { audit: true });

                getTeam();
            } catch (err) {
                if (err) {
                    log.error(err);
                    ShowErrorDialog({
                        error: `Failed to update user to ${role}`,
                        message: "Something went wrong. Please try again and reach out to support@beautiful.ai if the issue persists."
                    });
                }
            }
        });
    };

    handleUpgradeMember = async user => {
        const { team, getTeam, getFreshState, org, isActiveSubscription, totalSeatCount } = this.props;
        const usedSeatCount = getUsedSeatCount(team.members);

        //If there are not enough seats show AddTeamSeatDialog
        if (totalSeatCount - usedSeatCount <= 0) {
            if (isActiveSubscription) {
                ShowDialog(AddTeamSeatDialog, {
                    userId: user.id,
                    team,
                    org,
                    teamName: team.name,
                    teamMemberCount: team.members.length,
                    usedSeatCount,
                    currentSeatCount: totalSeatCount,
                    callback: () => getFreshState()
                });
            } else {
                ShowErrorDialog({ title: "Unable to add seats", message: "Seems like you cancelled the team subscription." });
            }
            return;
        }

        //If there are enough seats and the team is a pro-team assign a seat to a user
        try {
            await Api.teams.put({
                orgId: org.id,
                teamId: team.id,
                type: "add_user_to_seat",
                userIds: [user.id]
            });

            const props = {
                workspace_id: org.id,
                affected_user: user.id,
                old_role: AnalyticsRolesAndLicensesMap[user.role],
                new_role: AnalyticsRolesAndLicensesMap[user.role],
                old_license: AnalyticsRolesAndLicensesMap["free"],
                new_license: AnalyticsRolesAndLicensesMap["team_pro"]
            };
            trackActivity("Organization", "UserStatusChanged", null, null, props, { audit: true });

            getTeam();
            if (user.id === app.user.id) {
                ShowMessageDialog({
                    title: "Your seat has been added.",
                    message: "Your browser will be refreshed for the change to take effect.",
                    onClick: this.refreshApp,
                    onBackdropClick: this.refreshApp
                });
            }
        } catch (err) {
            if (err) {
                log.error(err);
                ShowErrorDialog({
                    error: "Failed to upgrade user",
                    message: "Something went wrong. Please try again and reach out to support@beautiful.ai if the issue persists."
                });
            }
        }
    };

    handleDowngradeMember = async user => {
        const { team, getTeam, org } = this.props;

        const title = user.id === app.user.id
            ? `Are you sure you want to downgrade yourself ?`
            : `Are you sure you want to downgrade ${user.displayName || user.email}`;
        const message = user.id === app.user.id
            ? "You will lose all Team features (fonts, folders, unlimited slides, etc..) if your billing is not managed by another team or yourself."
            : "They will also lose Team features (fonts, folders, unlimited slides, etc..) if this team is their only source of Team features and they will be changed to a Member role.";

        ShowConfirmationDialog({
            title,
            message
        }).then(async accept => {
            if (!accept) {
                return;
            }
            try {
                await Api.teams.put({
                    orgId: org.id,
                    teamId: team.id,
                    type: "remove_user_from_seat",
                    userIds: [user.id]
                });

                const props = {
                    workspace_id: org.id,
                    affected_user: user.id,
                    old_role: AnalyticsRolesAndLicensesMap[user.role],
                    new_role: AnalyticsRolesAndLicensesMap[user.role],
                    old_license: AnalyticsRolesAndLicensesMap["team_pro"],
                    new_license: AnalyticsRolesAndLicensesMap["free"]
                };
                trackActivity("Organization", "UserStatusChanged", null, null, props, { audit: true });

                getTeam();
                if (user.id === app.user.id) {
                    ShowMessageDialog({
                        title: "Your seat has been removed.",
                        message: "Your browser will be refreshed for the change to take effect.",
                        onClick: this.refreshApp,
                        onBackdropClick: this.refreshApp
                    });
                }
            } catch (err) {
                if (err) {
                    log.error(err);
                    ShowErrorDialog({
                        error: "Failed to downgrade user",
                        message: "Something went wrong. Please try again and reach out to support@beautiful.ai if the issue persists."
                    });
                }
            }
        });
    };

    getMemberPlan = member => {
        if (member.pending) {
            return member.license;
        }

        if (ds.teams.defaultTeamForOrg(this.props.organizationId).checkIfUserHasSeat(member)) {
            return "team_pro";
        }

        return "free";
    };

    renderRemoveAction = member => {
        const { handleRemoveMember, team, getTeam, isDefault } = this.props;
        const { readyToDelete } = this.state;

        if (isDefault && app.user.getEmail() === member.email) {
            return null;
        }

        if (readyToDelete[member.email]) {
            return (
                <BackgroundClick onBackgroundClick={() => {
                    this.setState({ readyToDelete: {} });
                }}>
                    <ScaryButton onClick={() => {
                        if (member.pending) {
                            return this.handleRemoveInvite(member.email);
                        } else {
                            return handleRemoveMember(
                                team,
                                member,
                                team.members,
                                "manage",
                                getTeam,
                                isDefault
                            );
                        }
                    }}>
                        Remove
                    </ScaryButton>
                </BackgroundClick>
            );
        } else {
            return (
                <div className="show-on-hover" style={{ textAlign: "right" }}>
                    <Icon
                        iconName="delete"
                        onClick={() => {
                            this.setState(prevState => {
                                return {
                                    ...prevState,
                                    readyToDelete: {
                                        ...prevState.readyToDelete,
                                        [member.email]: true
                                    }
                                };
                            });
                        }}
                    />
                </div>
            );
        }
    }

    renderLicenseDropdown = member => {
        const { canManageTeam } = this.props;
        const isDisabled = (member.role !== TEAM_USER_ROLES.MEMBER && member.role !== TEAM_USER_ROLES.MEMBER_LICENSED) ||
            app.user.id === member.id;

        const options = [
            { label: "Team Pro", value: TEAM_USER_LICENSE_STATUS.TEAM_PRO, isDisabled },
            { label: "Free", value: TEAM_USER_LICENSE_STATUS.FREE, isDisabled }
        ];

        if (!member.license) {
            return "None";
        }

        const handleClick = member.license === "free"
            ? this.handleUpgradeMember
            : this.handleDowngradeMember;

        return (
            <Select value={member.license}
                onChange={event => handleClick(member)}
                disabled={!canManageTeam || isDisabled}
                disableUnderline
            >
                {options.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
            </Select>
        );
    }

    renderRoleDropdown = member => {
        const { canManageTeam } = this.props;
        const isDisabled = app.user.id === member.id || member.license === "free";
        const options = [
            {
                label: "Member",
                value: member.license === "free" ? TEAM_USER_ROLES.MEMBER : TEAM_USER_ROLES.MEMBER_LICENSED,
                isDisabled
            },
            { label: "Librarian", value: TEAM_USER_ROLES.LIBRARIAN, isDisabled },
            { label: "Owner", value: TEAM_USER_ROLES.OWNER, isDisabled }
        ];

        if (member.role == "Invitation pending") {
            return <PendingInvite><span>Pending Invite</span></PendingInvite>;
        }

        return (
            <Select value={member.role}
                onChange={event => this.handleRoleUpdate(member, event.target.value)}
                disabled={!canManageTeam || isDisabled}
                disableUnderline
            >
                {options.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
            </Select>
        );
    }

    sanitizeMembersForUI = team => {
        return team.members.map(member => {
            return {
                id: member.id,
                url: member.url,
                displayName: member.displayName || member.email,
                email: member.email,
                photoURL: member.photoURL,
                role: member.pending ? "Invitation pending" : member.role ? member.role : null,
                license: this.getMemberPlan(member),
                pending: !!member.pending
            };
        });
    }

    render() {
        const { team, isDefault, canManageTeam } = this.props;

        const members = this.sanitizeMembersForUI(team);

        return (
            <AppList data={members} showHeader>
                <ListField
                    field="displayName"
                    name="Member"
                    width="2fr"
                    type="bold"
                    sortable
                    renderer={member => <Profile profile={member} />}
                />
                {isDefault && <ListField field="role" name="Role" isSelectField sortable renderer={this.renderRoleDropdown} />}
                {isDefault &&
                    <ListField field="license" name="License" sortable isSelectField renderer={this.renderLicenseDropdown} />}
                {canManageTeam && <ListIcon iconName="delete" renderer={this.renderRemoveAction} width={80} />}
            </AppList>
        );
    }
}

export default TeamMembersList;

const PendingInvite = styled.div`
  span {
    color: orange;
    font-size: 16px;
    font-weight: 600;
  }
`;
